import {useEffect, useReducer, useState} from 'react';

const initialTimeState = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
};

enum TimeActions {
  SetTime = 'TimeActions/SetTime',
}
type TimerState = typeof initialTimeState;
type TimerAction = {
  type: TimeActions;
  payload: TimerState;
};

const reducerTimer = (state: TimerState, action: TimerAction): TimerState => {
  switch (action.type) {
    case TimeActions.SetTime:
      return {
        ...state,
        days: action.payload.days,
        hours: action.payload.hours,
        minutes: action.payload.minutes,
        seconds: action.payload.seconds,
      };
    default:
      throw new Error();
  }
};

const calculateCountDownDate = (timeInMs?: number) => {
  return timeInMs ? new Date().getTime() + Number(timeInMs) : new Date().setHours(24, 0, 0, 0);
};

const calculateTimeRemaining = (countDownDate?: number) => {
  const latestTime = new Date().getTime();
  const distance = countDownDate - latestTime;

  return {
    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
    hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((distance % (1000 * 60)) / 1000),
    distance,
  };
};

const useTimer = (timeInMs?: number) => {
  const [time, setTime] = useReducer(
    reducerTimer,
    calculateTimeRemaining(calculateCountDownDate(timeInMs)),
  );
  const [isTimeExpired, setIsTimeExpired] = useState(false);

  useEffect(() => {
    const countDownDate = calculateCountDownDate(timeInMs);

    // Update the count down every 1 second
    const x = setInterval(function () {
      const {days, hours, minutes, seconds, distance} = calculateTimeRemaining(countDownDate);
      setTime({
        type: TimeActions.SetTime,
        payload: {days, hours, minutes, seconds},
      });

      // If the count down is finished, write some text
      if (distance <= 0) {
        setIsTimeExpired(true);
        clearInterval(x);
      }
    }, 1000);
    return () => {
      clearInterval(x);
    };
  }, [timeInMs]);

  return {time, isTimeExpired};
};

export default useTimer;
